import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import { withUserType } from '../withUserType';
import OverviewShell from '../overview_shell/OverviewShell';

require('./SiteSurveysOverviewPage.less');

const SiteSurveysPage: FC<any> = ({ history, userType, childRoutes }): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => history.push(`/${userType}/siteSurveys/overview/${key}`),
		[]
	);

	const checkTabActive = useCallback((key) => {
		const pathname = history.location.pathname;
		return pathname.indexOf(key) !== -1;
	}, []);

	const tabs = [
		{
			key: 'all',
			name: 'Active',
		},
		{
			key: 'archived',
			name: 'Archived',
		},
		{
			key: 'walkthroughs',
			name: 'Walkthroughs',
		},
		{
			key: 'templates/overview',
			name: 'Templates',
		},
	];

	return (
		<>
			<Route
				path={`/${userType}/siteSurveys/overview`}
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: `/${userType}/siteSurveys/overview/all`,
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Site Surveys"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="siteSurveysPage"
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

export default withUserType(
	withRouter<any, any>(connect(mapStateToProps)(SiteSurveysPage as any)) as any
);
